<div class="chat-bot-header">
  <div class="chat-menu" [class.disabled]="isInprogress">
    <mat-icon class="menu-action" *ngIf="showMenuBtn" (click)="toggleLeftPanel()">menu</mat-icon>
    <mat-icon class="menu-action" *ngIf="showBackBtn" (click)="toggleBackBtn()">arrow_back</mat-icon>
    <div class="page-title" *ngIf="pageTitle">
      <ng-container>
        <span class="page-title-text">{{ pageTitle }}</span>
      </ng-container>
    </div>
  </div>
  <span class="chat-title" *ngIf="showTitle">
    <mat-icon class="ellis-ai" svgIcon="ellis-ai-v2"></mat-icon>
    Ellis AI
  </span>
  <div class="chat-actions">
    <mat-icon svgIcon="new-chat-v1" (click)="newSession()" [class.disabled]="isInprogress"></mat-icon>

    <mat-icon
      svgIcon="{{ windowSizeIncreased ? 'window-size-dec' : 'window-size-inc' }}"
      (click)="toggleWindowSize()"
      [class.disabled]="isInprogress"
    ></mat-icon>
    <mat-icon *ngIf="showCloseBtn" svgIcon="close-icon" (click)="closeChat()"></mat-icon>
  </div>
</div>
